import axios from "axios";

export default {
    find: (name) => axios.get(`/api/help/find/${name}`),
    save: (obj) => axios.post("/api/help/save", obj),
};
